module.exports = __webpack_public_path__ + "img/envelope_n3.052ba158.png";